import { useState, useRef, useCallback } from "react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { fetchGuarantorType } from "@/api/user/home";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import CustomButton from "@/shared/components/kit/button";
import { CircularProgress } from "@mui/material";
import ContentFirstTab from "../components/contentFirstTab";

interface ProviderStepProps {
    data: any;
    onSuccess: () => void;
}

const GuarantorStep = ({ data, onSuccess }: ProviderStepProps) => {
    const [selectedOption, setSelectedOption] = useState("");
    const [optionValue, setOptionValue] = useState("");
    const [dataForm, setDataForm] = useState({ NID: "", birthday: "", phoneNumber: "", guarantor_type: "" });
    const dataFormRef = useRef(dataForm);

    const handleOptionChange = useCallback((newValue: string) => {
        setSelectedOption(newValue);
    }, []);

    const handleFormValuesUpdate = useCallback((updaterFn: any) => {
        const newFormValues = updaterFn(dataFormRef.current);
        dataFormRef.current = newFormValues;
        setDataForm(newFormValues);
    }, []);

    const { mutate: submitGuarantor, isPending } = useMutation({
        mutationFn: fetchGuarantorType,
        onSuccess: () => {
            toast.success("اطلاعات با موفقیت ثبت شد");
            onSuccess();
        },
        onError: (error: AxiosError<{ message: string }>) => {
            toast.error(error?.response?.data?.message || "خطا در ثبت اطلاعات");
        },
    });

    const handleSubmit = useCallback(() => {
        const requestBodyMyself = {
            NID: data?.nid,
            guarantor_type: dataFormRef.current?.guarantor_type,
            phoneNumber: data?.phone,
        };
        const requestBody = optionValue === "myself" ? requestBodyMyself : dataFormRef.current;
        if (selectedOption) {
            submitGuarantor(requestBody);
        } else {
            toast.warning("لطفاً یک گزینه را انتخاب کنید");
        }
    }, [selectedOption, optionValue, data, submitGuarantor]);

    const isDisabled = !selectedOption || isPending;

    return (
        <StackKit direction="column" sx={{ width: "100%", alignItems: "flex-start", height: "400px", justifyContent: "space-between" }}>
            <ContentFirstTab value={selectedOption} onChange={handleOptionChange} setFormValues={handleFormValuesUpdate} setOptionValue={setOptionValue}/>
            <StackKit direction="row" justifyContent="end" width="100%">
                <CustomButton onClick={handleSubmit} variant="contained" sx={{ mt: 3, width: "fit-content" }} disabled={isDisabled}>
                    <TypoGraphyKit variant="body1" sx={{ display: "flex", justifyContent: "center", alignItems: "center", minWidth: "50px" }}>
                        {isPending ? (
                            <CircularProgress sx={{ color: "#136A74" }} size={22} />
                        ) : "مرحله بعد"}
                    </TypoGraphyKit>
                </CustomButton>
            </StackKit>
        </StackKit>
    );
};

export default GuarantorStep;